module.exports = __webpack_public_path__ + "static/media/aq.02ad59b3.svg";